const utils = {}

// utils.install = function(Vue) {};
export default utils
